import { render, staticRenderFns } from "./EssayThemeSupportText.vue?vue&type=template&id=64f7431d&scoped=true&"
import script from "./EssayThemeSupportText.vue?vue&type=script&lang=ts&"
export * from "./EssayThemeSupportText.vue?vue&type=script&lang=ts&"
import style0 from "./EssayThemeSupportText.vue?vue&type=style&index=0&id=64f7431d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f7431d",
  null
  
)

export default component.exports